export default "__VITE_ASSET__Sm$D9Wa3__"